import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App';
import { FlagProvider } from '@unleash/proxy-client-react';

const config = {
  url: process.env.REACT_APP_UNLEASH_URL,
  clientKey: process.env.REACT_APP_UNLEASH_CLIENT_KEY,
  appName: process.env.REACT_APP_UNLEASH_APP_NAME,
  refreshInterval: Number(process.env.REACT_APP_UNLEASH_REFRESH_INTERVAL),
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <FlagProvider config={config}>     
          <App />    
      </FlagProvider>
    </BrowserRouter>
  </React.StrictMode>
);

